module.exports = __webpack_public_path__ + "img/ISO-9001-2015-Logo.18db5a02.png";